<template>
<div class="card carbon-foot-print">
  <div class="row">
    <div class="col-xs-5 col-sm-5 col-md-6 footprint">
      <img src="../../../assets/foot-print.svg" alt="carbon foot print icon">
      <small>Your Gas Carbon Footprint</small>
      <h6>{{ data.carbonFootprint | number(1) }} <small>tons CO<sub>2</sub> /year</small></h6>
    </div>

    <div class="col-xs-7 col-sm-7 col-md-6 equivalent">
      <b><small>You will be able to offset this carbon once you have completed your switch</small></b>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'CarbonFootPrint',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="scss">
.carbon-foot-print {
  display: block;
  max-width: 450px;
  width: 100%;
  border-radius: 10px;

  .footprint {
    position: relative;
    padding: 10px 0 0 45px !important;

    img {
      position: absolute;
      max-width: 22px;
      top: 10px;
      left: 13px;
    }
  }

  .footprint {
    small {
      h6 {
        display: inline;
      }
    }

    h5, h6 {
      margin: 0;
    }
  }

  @media(max-width: 767px) {
    max-width: none;
    margin-top: 10px;
  }
}
</style>
